/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Ai_Actions_5Inputs */

const en_pricing_feature_ai_actions_5 = /** @type {(inputs: Pricing_Feature_Ai_Actions_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 AI actions / month`)
};

const de_pricing_feature_ai_actions_5 = /** @type {(inputs: Pricing_Feature_Ai_Actions_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 KI-Aktionen / Monat`)
};

const fr_pricing_feature_ai_actions_5 = /** @type {(inputs: Pricing_Feature_Ai_Actions_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 actions IA / mois`)
};

const es_pricing_feature_ai_actions_5 = /** @type {(inputs: Pricing_Feature_Ai_Actions_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 Acciones IA / mes`)
};

const it_pricing_feature_ai_actions_5 = /** @type {(inputs: Pricing_Feature_Ai_Actions_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 azioni AI / mese`)
};

const nl_pricing_feature_ai_actions_5 = /** @type {(inputs: Pricing_Feature_Ai_Actions_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 AI-acties / maand`)
};

const pl_pricing_feature_ai_actions_5 = /** @type {(inputs: Pricing_Feature_Ai_Actions_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 akcji AI / miesiąc`)
};

const fi_pricing_feature_ai_actions_5 = /** @type {(inputs: Pricing_Feature_Ai_Actions_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 AI-toimintoa / kuukausi`)
};

const da_pricing_feature_ai_actions_5 = /** @type {(inputs: Pricing_Feature_Ai_Actions_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 AI-handlinger / måned`)
};

const sv_pricing_feature_ai_actions_5 = /** @type {(inputs: Pricing_Feature_Ai_Actions_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 AI-aktioner / månad`)
};

/**
* | output |
* | --- |
* | "5 AI actions / month" |
*
* @param {Pricing_Feature_Ai_Actions_5Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_ai_actions_5 = /** @type {((inputs?: Pricing_Feature_Ai_Actions_5Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Ai_Actions_5Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_feature_ai_actions_5(inputs)
	if (locale === "fr") return fr_pricing_feature_ai_actions_5(inputs)
	if (locale === "es") return es_pricing_feature_ai_actions_5(inputs)
	if (locale === "it") return it_pricing_feature_ai_actions_5(inputs)
	if (locale === "nl") return nl_pricing_feature_ai_actions_5(inputs)
	if (locale === "pl") return pl_pricing_feature_ai_actions_5(inputs)
	if (locale === "fi") return fi_pricing_feature_ai_actions_5(inputs)
	if (locale === "da") return da_pricing_feature_ai_actions_5(inputs)
	if (locale === "sv") return sv_pricing_feature_ai_actions_5(inputs)
	return en_pricing_feature_ai_actions_5(inputs)
});